import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>Maikon Farias</h1>
        <p className="Sub-title">Software Developer</p>
        
      </header>
      <div className="App-content">

        <h2 className="section-title">About</h2>
        <p>My name is Maikon Farias, originally from Brazil, lived in Canada for 3 years and now since 2019 I am in Munich, Germany to stay.</p>
        <h2 className="section-title">Languages</h2>
        <ul>
          <li><img className="country-flag" src="images/flag-brazil.png" /> <b>Portuguese:</b> native</li>
          <li><img className="country-flag" src="images/flag-canada.png" /> <b>English:</b> fluent (C1)</li>
          <li><img className="country-flag" src="images/flag-germany.png" /> <b>German:</b> good (B2)</li>
        </ul>

        <h2 className="section-title">Skills</h2>
        <p>Most of my experience is related to web and mobile apps development, slightly more frontend, but I am comfortable with fullstack development as well.</p>
        <ul>
          <li><img className="skill-flag" src={logo} /><img className="skill-flag" src="images/js-logo.png" /> <b>ReactJS, React Native, TypeScript, JavaScript:</b> advanced</li>
          <li><img className="skill-flag" src="images/php-logo.png" /> <img className="skill-flag" src="images/csharp-logo.png" /> <b>PHP, C#, Vue.JS, Unity, Python:</b> professionally experienced</li>
          <li><img className="skill-flag" src="images/nodejs-logo.png" /> <img className="skill-flag" src="images/unreal-logo.png" /> <b>NodeJS, NextJS, C++, Unreal:</b> wished (I want)</li>
        </ul>

        <h2 className="section-title">Contact</h2>
        <ul>
          <li>
            <a href="https://www.linkedin.com/in/maikonfarias/"> <img className="country-flag" src="images/linkedin-logo.png" /> LinkedIn</a>
          </li>
          <li>
            <a href="https://www.xing.com/profile/Maikon_Farias/cv"> <img className="country-flag" src="images/xing-logo.png" /> Xing</a>
          </li>
          <li>
            <a href="https://github.com/maikonfarias"> <img className="country-flag" src="images/github-logo.png" /> GitHub</a>
          </li>
          <li>
            <a href="https://www.facebook.com/maikonfarias/"> <img className="country-flag" src="images/facebook-logo.png" /> Facebook </a>
          </li>
        </ul>
      </div>

    </div>
  );
}

export default App;
